var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dropDown',{class:_vm.$style.dropDown,attrs:{"nodeId":"dealer-codes-select","label":_vm.label('dealerCodes'),"name":'dealerCode',"items":_vm.list_dealer_codes},on:{"selection":_vm.selection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }